import {DELETE_PERIOD_HANDLER_CURRENT_REQUEST} from "../../../enums/Request/currentRequestControls.types";

export const deletePeriodHandlerCurrentRequest = (index) => {
    return {
        type: DELETE_PERIOD_HANDLER_CURRENT_REQUEST,
        payload: index,
    };
};
